<template>
  <avue-tree ref="treeRef"
    class="transparent-arrow"
    node-key="id"
    :option="treeOption"
    :data="treeData"
    v-model="form"
    @node-click="nodeClick">
    <template #="{ node, data }">
      <span class="el-tree-node__label" style="flex: 1; margin-left: -18px;">
        <comp-icon name="directory_folder" size="18px" style="margin-right: 8px;"></comp-icon>
        <span style=" flex: 1;">{{ (node || {}).data.title }}</span>
      </span>
      <i class="icon-fenlei" style="margin-right: 8px;"></i>
    </template>
    <!-- <template #="{ node, data }">
      <span class="el-tree-node__label">
        <i class="icon-a-directorytree_01_network-alt" style="padding-right: 4px; font-size: 16px;"></i>
        {{ (node || {}).data.title }}
      </span>
    </template> -->
    <template #menu="{ node }">
      <div v-if="node.level < 2" class="avue-tree__item" @click="addSubType(node)">{{ Lang.btn.addChildren }}</div>
      <div class="avue-tree__item" @click="editType(node)">{{ Lang.btn.edit }}</div>
      <div class="avue-tree__item" @click="deleteType(node)">{{ Lang.btn.delete }}</div>
    </template>
  </avue-tree>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick  } from 'vue';
import { getTree, remove, save, update, getDetail, setTop } from '@/api/assemble/tree';

import { ElMessage, ElMessageBox } from 'element-plus';
import { Lang } from '@/lang/lang';

const form = reactive({});
const treeData = ref([]);
const treeOption = reactive({
  filterText: Lang.tips.plzInputFilterText,
  defaultExpandAll: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  props: {
    labelText: Lang.tips.title,
    label: 'title',
    value: 'id',
    children: 'children',
  },
});

const treeRef = ref(null);

const updateSideList = (list) => {
  treeData.value = [];
  if (list.length) {
    treeData.value = list;
    emit('getData', list);
  }
};

const addSubType = (node) => emit('addSubType', node);
const editTable = (node) => emit('editTable', node);
const editType = (node) => emit('editType', node);
const deleteType = (node) => emit('deleteType', node);
const deleteTable = (node) => emit('deleteTable', node);
// (node, data, done, loading) => handleDelete(node, data, done, loading);

const handleSubmit = (node, data, done, loading) => {
  const params = { parentId: node.data.id, ...data };
  save(params).then(
    () => {
      emit('refresh');
      done();
      ElMessage({ type: 'success', message: Lang.tips.operationSuccess });
      getTreeData();
    },
    error => {
      console.error(error);
      loading();
    }
  );
};

const handleUpdate = (node, data, done, loading) => {
  emit('update', node, data, done, loading);
  update(data).then(
    () => {
      emit('refresh');
      ElMessage({ type: 'success', message: Lang.tips.operationSuccess });
      getTreeData();
      done();
    },
    error => {
      console.error(error);
      loading();
    }
  );
};

const handleDelete = (node, data, done, loading) => {
  const id = node.data.id;
  // emit('delete', node, data, done, loading);
  ElMessageBox.confirm(Lang.tips.ifConfirmDelete, {
    confirmButtonText: Lang.btn.confirm,
    cancelButtonText: Lang.btn.cancel,
    type: 'warning',
  }).then(() => remove(id))
    .then(() => {
      emit('refresh');
      ElMessage({ type: 'success', message: Lang.tips.operationSuccess });
      getTreeData();
    });
};

const nodeClick = (data, Node, node) => {
  emit('nodeClick', data);
};

// 初始化获取树形数据
onMounted(() => {
  getTreeData();
});

// 默认选中第一个
const selectedFirstItem = (list) => {
  const firstItem = list[0];
  if (firstItem && firstItem.children) {
    const children = firstItem.children;
    const secondLevelFirstItem = children[0];
    if (secondLevelFirstItem && secondLevelFirstItem.id) {
      if (treeRef && treeRef.value) {
        treeRef.value.setCheckedKeys([secondLevelFirstItem.id]);
        treeRef.value.setCurrentKey(secondLevelFirstItem.id);
      }
      nodeClick(secondLevelFirstItem);
    }
  } else {
    if (treeRef && treeRef.value) {
      if (firstItem) {
        treeRef.value.setCheckedKeys([firstItem.id]);
        treeRef.value.setCurrentKey(firstItem.id);
      }
    }
    nodeClick(firstItem);
  }
};

const getTreeData = async () => {
  const res = await getTree();
  const list = res.data.data;
  updateSideList(list);
  nextTick(() => {
    selectedFirstItem(list)
  })
};

const emit = defineEmits(['addSubType', 'editTable', 'editType', 'nodeClick', 'deleteTable', 'deleteType', 'refresh', 'getData']);
defineExpose({
  getTreeData,
})
</script>
